export default __webpack_public_path__ + "static/media/v6.bf4857d5.jpg";